var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { VerticalCardLoader } from "syf-component-library/ui/atoms";
import { ModalFooter } from "syf-component-library/ui/patterns/SlideInModalPortal";
import { Inset, Stack } from "syf-component-library/ui/spacing";
import { SNAPSHOT } from "../../../../../const/analytics";
import { useRewardsConfigContext } from "../../../../../context/rewardsConfig";
import { getSelectedAccountId } from "../../../../../helpers/sessionAccountId";
import useRewards from "../../../../../hooks/useRewards";
import useRewardsAnalytics from "../../../../../hooks/useRewardsAnalytics";
import RewardBanner from "../../../../../ui/atoms/RewardBanner";
import RewardsFaqs from "../../../../../ui/atoms/RewardsFaqs";
import Earnings from "../../../../../ui/molecules/Earnings";
import RewardsProgress from "../../../../../ui/molecules/RewardsProgress";
import ErrorPage from "../../../../../ui/templates/ErrorPage";
import { useRewardsModalConfigContext } from "../../../context/modalConfig";
import ModalDrawerHeader from "../../molecules/ModalDrawerHeader";
import { HorizontalBorder, LoadingWrapper, ModalContentWrapper, ModalRewardsWrapper, ModalWrapper, } from "./subcomponents";
var ModalContent = function () {
    var _a, _b;
    var goToRewardsPage = useRewardsModalConfigContext().goToRewardsPage;
    var config = useRewardsConfigContext().config;
    var t = useTranslation().t;
    var selectedAccountId = getSelectedAccountId();
    if (!selectedAccountId) {
        throw new Error("selectedAccountId is not defined");
    }
    var _c = useRewards(), accountSummary = _c.accountSummary, allRewardsCertificate = _c.allRewardsCertificate, certificates = _c.certificates, clientId = _c.clientId, cardType = _c.cardType, hasCertificateHistory = _c.hasCertificateHistory, isError = _c.isError, isLoading = _c.isLoading, rewardDetails = _c.rewardDetails, rewardsExperience = _c.rewardsExperience;
    useRewardsAnalytics({
        allRewardsCertificate: allRewardsCertificate,
        pageSubFunction: SNAPSHOT,
        clientName: clientId,
    });
    if (isError) {
        return _jsx(ErrorPage, { config: config });
    }
    if (isLoading) {
        return (_jsx(LoadingWrapper, { children: _jsx(VerticalCardLoader, {}) }));
    }
    var imageBanner = (_a = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _a === void 0 ? void 0 : _a[cardType].banner;
    var faqsSnapshot = (_b = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _b === void 0 ? void 0 : _b.faqsSnapshot;
    return (_jsxs(ModalWrapper, { children: [_jsxs(ModalContentWrapper, { children: [accountSummary && (_jsx(ModalDrawerHeader, { accountSummary: accountSummary })), _jsx(Stack, { size: "large", hideOnBreakpointDown: "small" }), _jsx(Inset, __assign({ vertical: "base", hideOnBreakpointUp: "small" }, { children: _jsx(HorizontalBorder, {}) })), _jsxs(ModalRewardsWrapper, __assign({ all: "large", hideOnBreakpointDown: "medium" }, { children: [imageBanner && (_jsx(RewardBanner, { client: clientId, image: imageBanner })), rewardsExperience && (_jsxs(_Fragment, { children: [hasCertificateHistory ? (_jsx(RewardsProgress, { className: "inside-drawer", certificate: certificates, rewardDetails: rewardDetails, rewardsExperience: rewardsExperience, client: clientId })) : (_jsx(Earnings, { className: "inside-drawer" })), faqsSnapshot && (_jsx(RewardsFaqs, { className: "inside-drawer", client: clientId, rewardsExperience: rewardsExperience }))] }))] }))] }), _jsx(ModalFooter, { primaryText: t("modal.footer.rewardsButton"), handlePrimaryButton: goToRewardsPage, dataPrimaryObject: "button", dataPrimaryType: "rewards snapshot", dataPrimaryReason: "view full reward details" })] }));
};
export default ModalContent;
